export const FUNCTIONALITIES = {
  exportDailyReport: "EXPORT_REPORT_DAILY",
  createExport: "CREATE_EXPORT",
  createImport: "CREATE_IMPORT",
  profileOffice: "PROFILE_OFFICE",
  templates: "TEMPLATES",
  exportMazda: "EXPORT_MAZDA",
};
